import * as React from 'react'
import { Route, RouteProps, Redirect } from 'react-router'
import { isAuthenticated, removeToken } from '../utils/auth'
import MeQuery from './queries/MeQuery'
import { UserRole } from '../graphql/queries/me'

interface SecureRouteProps extends RouteProps {
  role?: UserRole
}

const SecureRoute: React.SFC<SecureRouteProps> = ({
  role,
  component: Component,
  render,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => {
        const redirect = () => {
          removeToken()

          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location }
              }}
            />
          )
        }

        if (!isAuthenticated()) {
          return redirect()
        }

        const toRender =
          Component != null ? (
            <Component {...props} />
          ) : render != null ? (
            render(props)
          ) : (
            <div />
          )

        return (
          <MeQuery>
            {({ data, loading, error }) => {
              if (loading) {
                return <div />
              }

              if (data == null) {
                return redirect()
              }

              if (role != null && data.user.roles.indexOf(role) === -1) {
                return redirect()
              }

              return toRender
            }}
          </MeQuery>
        )
      }}
    />
  )
}

export default SecureRoute



// WEBPACK FOOTER //
// ./src/components/SecureRoute.tsx